module.exports = __webpack_public_path__ + "img/no_in_progress_demand.eb20d3a4.svg";